const committeeOutline = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_10138_582)'>
      <path
        d='M14 20V22H2V20H14ZM14.586 0.686L22.364 8.464L20.95 9.88L19.89 9.526L17.413 12L23.07 17.657L21.656 19.071L16 13.414L13.596 15.818L13.879 16.95L12.464 18.364L4.686 10.586L6.101 9.172L7.231 9.454L13.525 3.161L13.172 2.101L14.586 0.686ZM15.293 4.222L8.222 11.292L11.757 14.828L18.828 7.758L15.293 4.222Z'
        fill='#000000'
      />
    </g>
    <defs>
      <clipPath id='clip0_10138_582'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export default committeeOutline;
